import { Card, CardContent, Typography, Box } from '@mui/material';

interface StatsCardProps {
    title: string;
    value: string | number;
    change?: string;
}

const StatsCard = ({ title, value, change }: StatsCardProps) => {
    return (
        <Card
            sx={{
                minWidth: 350,
                background: 'rgb(159, 204, 46)',
                borderRadius: 4,
                color: '#000000',
                boxShadow: '0 8px 10px #00000040',
            }}
        >
            <CardContent>
                <Box display="flex" justifyContent="space-between" alignItems="center">
                    <Typography variant="h6" style={{ fontWeight: 'bold' }} gutterBottom>
                        {title}
                    </Typography>
                    <Typography variant="h4" component="div" style={{ fontWeight: 'bold' }}>
                        {value.toLocaleString('en-US')}
                    </Typography>
                </Box>
                <div style={{ height: "20px" }} />
                <Typography variant="body2" style={{ height: "20px" }}>
                {change !== undefined && change !== null && Number(change) > 0 ? `Change from last week: +${change}` : '                            '}
                </Typography>
            </CardContent>
        </Card>
    );
};

export default StatsCard;